export default function useBrowserMode() {
    const isBrowser = typeof window !== 'undefined';
    return { isBrowser }
}